(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["propellant"] = factory();
	else
		root["propellant"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 38);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return events; });
/* harmony export (immutable) */ __webpack_exports__["a"] = eventSetup;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return collapse; });
var events = void 0;



function eventSetup(Vue) {
  events = new Vue();
}

var modal = {
  hide: function hide(name) {
    events.$emit('modal:hide', name);
  },
  show: function show(name) {
    events.$emit('modal:show', name);
  }
};

var toast = {
  push: function push(opts, force) {
    events.$emit('toast:push', opts, force);
  },
  hide: function hide(clear) {
    events.$emit('toast:hide', clear);
  }
};

var collapse = {
  hide: function hide(namespace, name) {
    events.$emit('collapse:hide', namespace, name);
  },
  show: function show(namespace, name) {
    events.$emit('collapse:show', namespace, name);
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collapse_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collapse_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__collapse_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__input_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__popup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sectionBar_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sectionBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__sectionBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__select_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__switchbox_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__switchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__switchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__textarea_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__textarea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__textarea_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toast_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__toast_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_0__checkbox_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pCollapse", function() { return __WEBPACK_IMPORTED_MODULE_1__collapse_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pInput", function() { return __WEBPACK_IMPORTED_MODULE_2__input_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pModal", function() { return __WEBPACK_IMPORTED_MODULE_3__modal_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pPopup", function() { return __WEBPACK_IMPORTED_MODULE_4__popup_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pSectionbar", function() { return __WEBPACK_IMPORTED_MODULE_5__sectionBar_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pSelect", function() { return __WEBPACK_IMPORTED_MODULE_6__select_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pSwitchbox", function() { return __WEBPACK_IMPORTED_MODULE_7__switchbox_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pTextarea", function() { return __WEBPACK_IMPORTED_MODULE_8__textarea_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pToast", function() { return __WEBPACK_IMPORTED_MODULE_9__toast_vue___default.a; });













/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_src__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_events__ = __webpack_require__(1);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pCheckbox"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pCollapse", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pCollapse"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pInput", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pInput"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pModal", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pModal"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pPopup", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pPopup"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pSectionbar", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pSectionbar"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pSelect", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pSelect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pSwitchbox", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pSwitchbox"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pTextarea", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pTextarea"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pToast", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_src__["pToast"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "events", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_events__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "eventSetup", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_events__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "modal", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_events__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toast", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_events__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "collapse", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_events__["b"]; });



var propellant = __WEBPACK_IMPORTED_MODULE_0__vue_src__;

propellant.install = function (Vue, options) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue_events__["a" /* eventSetup */])(Vue);
  for (var component in __WEBPACK_IMPORTED_MODULE_0__vue_src__) {
    if (__WEBPACK_IMPORTED_MODULE_0__vue_src__[component].name) {
      Vue.component(__WEBPACK_IMPORTED_MODULE_0__vue_src__[component].name, __WEBPACK_IMPORTED_MODULE_0__vue_src__[component]);
    }
  }
  Object.defineProperty(Vue.prototype, '$collapse', { get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1__vue_events__["b" /* collapse */];
    } });
  Object.defineProperty(Vue.prototype, '$modal', { get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1__vue_events__["c" /* modal */];
    } });
  Object.defineProperty(Vue.prototype, '$toast', { get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1__vue_events__["d" /* toast */];
    } });
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(propellant);
}

/* harmony default export */ __webpack_exports__["default"] = (propellant);



/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pCheckbox',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default.a],
  props: {
    label: {
      type: String,
      default: '',
      note: "a label to be appended after the checkbox"
    },
    indeterminate: {
      type: Boolean,
      default: false,
      note: "whether the checkbox should initially be indeterminate"
    }
  },
  mounted: function mounted() {
    if (this.indeterminate) this.$el.querySelector('input').indeterminate = true;
  },

  methods: {
    stateFromEvent: function stateFromEvent(e) {
      return e.target.checked;
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_js__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function easeInOutQuart(t) {
  var t1 = t - 1;
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * t1 * t1 * t1 * t1;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pCollapse',
  props: {
    expanded: {
      type: Boolean,
      default: false,
      note: "can be used to set the initial expansion state"
    },
    ns: {
      type: String,
      default: undefined,
      note: "when set, all collapse that share the same namespace will function as an accordion"
    },
    name: {
      type: String,
      required: true,
      note: "a unique name for the collapse"
    }
  },
  created: function created() {
    var _this = this;

    if (this.ns) {
      __WEBPACK_IMPORTED_MODULE_0__events_js__["e" /* events */].$on('collapse:accordion', function (ns, name) {
        if (_this.ns === ns && _this.name !== name) {
          _this.hide();
        }
      });
    }
  },
  data: function data() {
    return { isExpanded: this.expanded };
  },

  computed: {
    hasPromptSlots: function hasPromptSlots() {
      return this.$slots.showmore;
    }
  },
  methods: {
    show: function show() {
      this.isExpanded = true;
    },
    hide: function hide() {
      this.isExpanded = false;
    },
    toggle: function toggle() {
      this.isExpanded = !this.isExpanded;
      if (this.ns && this.isExpanded) {
        __WEBPACK_IMPORTED_MODULE_0__events_js__["e" /* events */].$emit('collapse:accordion', this.ns, this.name);
      }
    },
    beforeEnter: function beforeEnter(el) {
      el.style.height = 0;
    },
    enter: function enter(el, done) {
      el.style.height = "100%";
      var dest = el.getBoundingClientRect().height;
      el.style.height = "0px";
      var targetTime = 400;
      var start = null;
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var percentage = progress / targetTime;
        el.style.height = easeInOutQuart(percentage) * dest + 'px';
        if (progress < targetTime) {
          window.requestAnimationFrame(step);
        } else {
          done();
        }
      }
      window.requestAnimationFrame(step);
      this.$emit("collapse:shown");
    },
    leave: function leave(el, done) {
      var original = el.getBoundingClientRect().height;
      var targetTime = 400;
      var start = null;
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var percentage = progress / targetTime;
        el.style.height = original - easeInOutQuart(percentage) * original + 'px';
        if (progress < targetTime) {
          window.requestAnimationFrame(step);
        } else {
          done();
        }
      }
      window.requestAnimationFrame(step);
      this.$emit("collapse:hidden");
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    emitEvents: {
      type: Boolean,
      default: false,
      note: "whether or not the component should emit events when shown/hidden"
    }
  },
  data: function data() {
    return {
      visible: false,
      didEmit: false
    };
  },

  methods: {
    show: function show() {
      this.visible = true;
      document.body.classList.add(this.bodyClassName);
      if (this.emitEvents) {
        this.didEmit = false;
        this.shown();
      }
    },
    hide: function hide() {
      this.visible = false;
      document.body.classList.remove(this.bodyClassName);
      if (this.emitEvents) {
        this.didEmit = false;
        this.hidden();
      }
    },
    shown: function shown() {
      if (!this.$el.querySelector) {
        window.requestAnimationFrame(this.shown);
      } else if (!this.didEmit) {
        this.didEmit = true;
        this.$emit('shown');
      }
    },
    hidden: function hidden() {
      if (this.$el.querySelector) {
        window.requestAnimationFrame(this.hidden);
      } else if (!this.didEmit) {
        this.didEmit = true;
        this.$emit('hidden');
      }
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var default_opts = {
  msg: '',
  icon: '',
  class: ''
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pInput',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default.a],
  props: {
    placeholder: {
      type: String,
      default: '',
      note: "a placeholder for the input field"
    },
    validator: {
      type: Function
    }
  },
  data: function data() {
    return {
      validationIcon: '',
      validationMsg: '',
      validationClass: ''
    };
  },

  methods: {
    stateFromEvent: function stateFromEvent(e) {
      return e.target.value;
    },
    validateAndChange: function validateAndChange(e) {
      var value = e.target.value;
      if (this.validator) {
        var result = Object.assign({}, default_opts, this.validator(value));
        this.validationIcon = result.icon;
        this.validationMsg = result.msg;
        this.validationClass = result.class;
      }
      this.onChange(e);
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      required: true,
      note: "a model object the component should bind to"
    },
    disabled: {
      type: Boolean,
      default: false,
      note: "whether the element is disabled or not"
    },
    label: {
      type: String,
      note: "a label to be placed before the form field"
    },
    uid: {
      type: String,
      note: "a unique identifier for the component, used to bind labels to inputs"
    }
  },
  data: function data() {
    return {
      focused: false,
      id: this.generateID()
    };
  },

  computed: {
    innerModel: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    hasLabel: function hasLabel() {
      return this.label !== undefined;
    }
  },
  methods: {
    generateID: function generateID() {
      if (this.uid) return this.uid;
      if (this.label === undefined) return "";
      return "p" + Math.random().toString(16).slice(2) + Date.now();
    },
    onChange: function onChange(e) {
      this.$emit('input', this.stateFromEvent(e));
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dialog_mixin_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dialog_mixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dialog_mixin_vue__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pModal',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__dialog_mixin_vue___default.a],
  props: {
    name: {
      type: String,
      default: undefined,
      note: "only modal components with a name set will listen for events"
    }
  },
  created: function created() {
    var _this = this;

    if (this.name) {
      __WEBPACK_IMPORTED_MODULE_0__events_js__["e" /* events */].$on('modal:show', function (name) {
        if (_this.name === name) _this.show();
      });
      __WEBPACK_IMPORTED_MODULE_0__events_js__["e" /* events */].$on('modal:hide', function (name) {
        if (_this.name === name) _this.hide();
      });
    }
  },
  data: function data() {
    return {
      bodyClassName: 'p-modal-showing',
      showingSelector: '.p-modal-container'
    };
  },

  methods: {
    eventHide: function eventHide(e) {
      if (e.currentTarget === this.$refs.backdrop && e.target !== e.currentTarget) return;
      this.hide();
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_mixin_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_mixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dialog_mixin_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pPopup',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__dialog_mixin_vue___default.a],
  data: function data() {
    return {
      bodyClassName: 'p-popup-showing',
      showingSelector: '.p-popup-container'
    };
  },

  props: {
    title: {
      type: String,
      default: undefined
    },
    closeButton: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pSectionbar',
  props: {
    colorBar: {
      type: String,
      default: undefined,
      note: 'a css class to append to the entire sectionbar, useful for setting a border property'
    },
    icon: {
      type: String,
      default: undefined,
      note: 'location to an icon that will be brought in via background-image'
    },
    callout: {
      type: String,
      default: undefined,
      note: 'a callout on the right of the sectionbar, one of: chevron, hamburger, hotdog, plus'
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pSelect',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default.a],
  props: {
    multiple: {
      type: Boolean,
      default: false,
      note: "controls if the element should be a multi-select or not"
    }
  },
  methods: {
    stateFromEvent: function stateFromEvent(e) {
      if (!this.multiple) return e.target.value;
      var result = [];
      var options = e.target.options;
      for (var i = 0, length = options.length; i < length; i++) {
        if (options[i].selected) result.push(options[i].value);
      }
      return result;
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pSwitchbox',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default.a],
  props: {
    labels: {
      type: Array,
      default: function _default() {
        return [];
      },
      note: "an array of labels in the form: [left-label, right-label]"
    }
  },
  methods: {
    stateFromEvent: function stateFromEvent(e) {
      return e.target.checked;
    }
  },
  computed: {
    leftLabel: function leftLabel() {
      return this.labels[0] ? this.labels[0] : "";
    },
    rightLabel: function rightLabel() {
      return this.labels[1] ? this.labels[1] : "";
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue__);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pTextarea',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__inputs_mixin_vue___default.a],
  props: {
    placeholder: {
      type: String,
      default: '',
      note: "a placeholder for the textarea field"
    }
  },
  methods: {
    stateFromEvent: function stateFromEvent(e) {
      return e.target.value;
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_js__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//



var default_opts = {
  msg: "<h3>Salutations, I am a toast.</h3>",
  type: "",
  timeout: 3600
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pToast',
  props: {
    noEvents: {
      type: Boolean,
      default: false,
      note: "disables the creation of event listeners"
    }
  },
  created: function created() {
    var _this = this;

    if (this.noEvents) return;
    __WEBPACK_IMPORTED_MODULE_0__events_js__["e" /* events */].$on('toast:push', function (opts, force) {
      if (force) {
        _this.clearTimer();
        _this.show(opts);
      } else {
        _this.push(opts);
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__events_js__["e" /* events */].$on('toast:hide', function (clear) {
      if (clear) _this.clearQueue();
      _this.hide();
    });
  },
  data: function data() {
    return {
      msg: "",
      type: "",
      showing: false,
      sleeping: false,
      timer: null,
      queue: []
    };
  },

  methods: {
    merge: function merge(opts) {
      return Object.assign({}, default_opts, opts);
    },
    push: function push(opts) {
      this.queue.push(this.merge(opts));
      this.checkQueue();
    },
    clearQueue: function clearQueue() {
      this.queue = [];
    },
    clearTimer: function clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    checkQueue: function checkQueue() {
      if (this.showing === false && this.sleeping === false && this.queue.length > 0) {
        this.show(this.queue.shift());
      }
    },
    show: function show(t) {
      var _this2 = this;

      this.msg = t.msg;
      this.type = t.type;
      // timeout of 0 means never auto-hide
      if (t.timeout !== 0) {
        this.timer = setTimeout(function () {
          _this2.hide();
        }, t.timeout);
      }
      this.showing = true;
    },
    hide: function hide() {
      var _this3 = this;

      this.clearTimer();
      this.showing = false;
      this.sleeping = true;
      setTimeout(function () {
        _this3.sleeping = false;
        _this3.checkQueue();
      }, 500);
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(34),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(29),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(33),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(35),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(36),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(30),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(32),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(31),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(37),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "p-from-bottom"
    }
  }, [(_vm.visible) ? _c('aside', {
    ref: "backdrop",
    staticClass: "p-modal-backdrop",
    on: {
      "click": function($event) {
        _vm.eventHide($event)
      }
    }
  }, [_c('div', {
    staticClass: "p-modal-container"
  }, [_vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "p-collapse"
  }, [_c('div', {
    staticClass: "p-collapse-title",
    class: {
      expanded: _vm.isExpanded, clickable: !_vm.hasPromptSlots
    },
    on: {
      "click": function($event) {
        !_vm.hasPromptSlots && _vm.toggle()
      }
    }
  }, [_vm._t("title")], 2), _vm._v(" "), (_vm.hasPromptSlots) ? _c('div', {
    staticClass: "p-collapse-showmore p-clickable",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [(_vm.isExpanded) ? _vm._t("showless") : _vm._t("showmore")], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.isExpanded) ? _c('div', {
    staticClass: "p-collapse-content"
  }, [_vm._t("content")], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-input-group has-select"
  }, [(_vm.hasLabel) ? _c('label', {
    staticClass: "p-input-label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "p-select-wrapper",
    class: {
      'multiple': _vm.multiple
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerModel),
      expression: "innerModel"
    }],
    staticClass: "p-select",
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.innerModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChange]
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-input-group has-textarea"
  }, [_c('label', {
    staticClass: "p-input-label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "p-input-wrapper"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerModel),
      expression: "innerModel"
    }],
    staticClass: "p-textarea",
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.innerModel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.innerModel = $event.target.value
      }, _vm.onChange]
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-input-group has-switchbox"
  }, [_c('label', {
    staticClass: "p-switchbox",
    class: {
      'focus': _vm.focused, 'disabled': _vm.disabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerModel),
      expression: "innerModel"
    }],
    attrs: {
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.innerModel) ? _vm._i(_vm.innerModel, null) > -1 : (_vm.innerModel)
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "focusout": function($event) {
        _vm.focused = false
      },
      "change": _vm.onChange,
      "__c": function($event) {
        var $$a = _vm.innerModel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.innerModel = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.innerModel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.innerModel = $$c
        }
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.leftLabel) + "\n    "), _c('span', {
    staticClass: "p-switch-lever"
  }), _vm._v("\n      " + _vm._s(_vm.rightLabel) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-input-group has-input",
    class: _vm.validationClass
  }, [(_vm.hasLabel) ? _c('label', {
    staticClass: "p-input-label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-input-wrapper",
    class: {
      'has-validation-icon': _vm.validationIcon !== '', 'has-hint': _vm.validationMsg
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerModel),
      expression: "innerModel"
    }],
    staticClass: "p-input",
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.innerModel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.innerModel = $event.target.value
      }, _vm.validateAndChange]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-input-validation-icon"
  }, [(_vm.validationIcon === 'alert') ? _c('svg', {
    staticClass: "p-input-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "16"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.validationIcon === 'success') ? _c('svg', {
    staticClass: "p-input-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 11.07V12a10 10 0 1 1-5.93-9.14"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "23 3 12 14 9 11"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.validationIcon === 'error') ? _c('svg', {
    staticClass: "p-input-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "p-input-hint"
  }, [_vm._v(_vm._s(_vm.validationMsg))])])
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-input-group has-checkbox"
  }, [_c('label', {
    staticClass: "p-checkbox",
    class: {
      'focus': _vm.focused, 'disabled': _vm.disabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerModel),
      expression: "innerModel"
    }],
    attrs: {
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.innerModel) ? _vm._i(_vm.innerModel, null) > -1 : (_vm.innerModel)
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "focusout": function($event) {
        _vm.focused = false
      },
      "change": _vm.onChange,
      "__c": function($event) {
        var $$a = _vm.innerModel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.innerModel = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.innerModel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.innerModel = $$c
        }
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.label) + "\n    "), _c('span', {
    staticClass: "p-check-lever"
  })])])
},staticRenderFns: []}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "p-fade-in"
    }
  }, [(_vm.visible) ? _c('aside', {
    staticClass: "p-popup-backdrop"
  }, [_c('div', {
    staticClass: "p-popup-container"
  }, [_c('div', {
    staticClass: "p-popup-titlebar"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.closeButton) ? _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-sectionbar",
    class: _vm.colorBar
  }, [_c('div', {
    staticClass: "p-sectionbar-color"
  }), _vm._v(" "), (_vm.icon) ? _c('div', {
    staticClass: "p-sectionbar-icon",
    style: ({
      backgroundImage: ("url(" + _vm.icon + ")")
    }),
    attrs: {
      "alt": "icon"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-sectionbar-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.callout) ? _c('div', {
    staticClass: "p-sectionbar-callout"
  }, [(_vm.callout === 'chevron') ? _c('svg', {
    attrs: {
      "id": "p-sectionbar-chevron",
      "viewBox": "0 0 32 32",
      "width": "18",
      "height": "18",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 30 L24 16 12 2"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.callout === 'hamburger') ? _c('svg', {
    attrs: {
      "id": "p-sectionbar-hamburger",
      "viewBox": "0 0 32 32",
      "width": "24",
      "height": "24",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 8 L28 8 M4 16 L28 16 M4 24 L28 24"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.callout === 'hotdog') ? _c('svg', {
    attrs: {
      "id": "p-sectionbar-hotdog",
      "viewBox": "0 0 32 32",
      "width": "24",
      "height": "24",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "16",
      "cy": "7",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "16",
      "cy": "16",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "16",
      "cy": "25",
      "r": "2"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.callout === 'plus') ? _c('svg', {
    attrs: {
      "id": "p-sectionbar-plus",
      "viewBox": "0 0 32 32",
      "width": "18",
      "height": "18",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 2 L16 30 M2 16 L30 16"
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "p-toast-bottom"
    }
  }, [_c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showing),
      expression: "showing"
    }],
    staticClass: "p-toast-wrapper"
  }, [_c('div', {
    staticClass: "p-toast-container",
    class: _vm.type
  }, [_c('span', {
    staticClass: "p-toast-message",
    domProps: {
      "innerHTML": _vm._s(_vm.msg)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js